// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTopButton_container__FOB+N","button":"ScrollToTopButton_button__eaFyW","fadeIn":"ScrollToTopButton_fadeIn__3cEYC","icon":"ScrollToTopButton_icon__r-JvI"};